import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './MaintenancePage.module.scss';
import { fetch as apiFetch } from 'src/utils/refetch';
import { createUrl } from 'src/core/api/utils/createUrl';

const POLL_INTERVAL = 60000;

interface MaintenancePageProps {
  text?: string;
}

const MaintenancePage: React.FC<MaintenancePageProps> = ({ text }) => {
  const { t } = useTranslation();
  useEffect(() => {
    const interval = setInterval(() => {
      apiFetch(createUrl('/prefetch'))
        .then((res:any) => {
          if (res.response.ok && res.body.user_country_code) {
            window.location.reload();
          }
        })
        .catch(() => {});
    }, POLL_INTERVAL);
    return () => clearInterval(interval);
  }, []);

    return (
        <div className={styles.body}>
            <img
                className={styles.centerImage}
                src="https://cdn-g.bluemovie.com/maintenance/bg_image.png"
                alt="Center Image"
            />

            <div className={styles.container}>
                <img
                    src="https://cdn-g.bluemovie.com/maintenance/subtract.png"
                    alt="Maintenance Icon"
                    className={styles.icon}
                />
                <div className={styles.textContainer}>
                    <h1>{t('maintenance.title')}</h1>
                    <p
                      className={styles.message}
                      dangerouslySetInnerHTML={{ __html: text || t('maintenance.defaultText') }}
                    />
                </div>
            </div>
        </div>
    );
};

export default MaintenancePage;
